import { render, staticRenderFns } from "./CompanionDate.vue?vue&type=template&id=230fc08e&"
import script from "./CompanionDate.vue?vue&type=script&lang=js&"
export * from "./CompanionDate.vue?vue&type=script&lang=js&"
import style0 from "./CompanionDate.vue?vue&type=style&index=0&id=230fc08e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports